// extracted by mini-css-extract-plugin
export var button = "_h0-0";
export var donut = "_h0-1";
export var donutFill = "_h0-3";
export var donutTrack = "_h0-2";